import { useEffect, useRef } from "react";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FacebookPageComponent() {
  const containerRef = useRef(null);

  useEffect(() => {
    const renderFacebook = () => {
      if (!containerRef.current) return;

      const page = containerRef.current.querySelector(".fb-page");
      if (!page) return;

      // Facebook Page Plugin supports widths between 180 and 500 px
      const width = Math.min(
        Math.max(containerRef.current.offsetWidth, 180),
        500,
      );

      page.setAttribute("data-width", width);

      if (window.FB) {
        page.innerHTML = "";
        window.FB.XFBML.parse(containerRef.current);
      }
    };

    renderFacebook();

    window.addEventListener("resize", renderFacebook);

    return () => window.removeEventListener("resize", renderFacebook);
  }, []);

  return (
    <div
      className="rounded-3 border-vcg-muted p-4 p-lg-5 mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-left"
    >
      <div className="text-center mb-4">
        <FontAwesomeIcon
          icon={faFacebook}
          size="3x"
          style={{ color: "#1877F2" }}
          className="mb-3"
        />

        <h3 className="fw-bold">Official Facebook Page</h3>

        <p
          className="text-muted mx-auto mb-0"
          style={{
            maxWidth: "750px",
            lineHeight: "1.7",
          }}
        >
          Stay connected with the latest announcements, events, photographs,
          achievements, and community activities from the Vidyaloka College
          Galle Old Boys' Association through our official Facebook page.
        </p>
      </div>

      <div
        className="border rounded-3 p-2 p-md-4 overflow-hidden"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <div ref={containerRef} className="d-flex justify-content-center">
          <div
            className="fb-page"
            data-href="https://www.facebook.com/vcgoba"
            data-tabs="timeline"
            data-height="700"
            data-small-header="false"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="false"
          >
            <blockquote
              cite="https://www.facebook.com/vcgoba"
              className="fb-xfbml-parse-ignore"
            >
              <a href="https://www.facebook.com/vcgoba">
                Vidyaloka College Galle OBA
              </a>
            </blockquote>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <a
          href="https://www.facebook.com/vcgoba"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary px-4"
        >
          <FontAwesomeIcon icon={faFacebook} className="me-2" />
          Visit Our Facebook Page
        </a>
      </div>
    </div>
  );
}
